import React, { useState, useCallback, useEffect } from "react";
import { debounce } from "lodash";
import "../Profile/index.less";
import "./index.less";
import Teams from "../../../assets/menu/Teams.png";
import E from "../../../models/E";
import CustomEmpty from "@/utils/CustomEmpty";
import { Button, Row, Col, Table, Form, Select, Space, Spin } from "antd";
import { effect, useStore } from "../../../utils/dva16";
import sortData from "../../../utils/sorter";
import {
	EGet,
	NGame,
	NTeam,
	EGetOne,
	EGetType,
	NOrganizationMulti,
	EGetCompany,
} from "../../../models/contants";
import { Pie, G2 } from "@ant-design/charts";
import { customizeRenderEmpty } from "../../../utils/utils";
import { Helmet } from "react-helmet";
const { Option } = Select;

export default (props) => {
	const { history } = props;
	const {
		location: { state },
	} = history;
	const [form] = Form.useForm();
	const [keyword, setKeyword] = useState({});
	const { TeamList, TeamTitle, loading, esportTeamSearch } = useStore(NTeam);
	const { OrganizationCompany } = useStore(NOrganizationMulti);
	const { gameSearch } = useStore(NGame);
	const [sortState, setSortState] = useState(null);
	let sortType = {
		ascend: "asc",
		descend: "desc",
	};

	const CompanyCharts = () => {
		const G = G2.getEngine("canvas");
		const [config, setConfig] = useState({
			data: [],
			height: 300,
			appendPadding: 10,
			angleField: "count",
			colorField: "region",
			radius: 0.75,
			legend: false,
			innerRadius: 0.6,
			statistic: {
				title: false,
				content: false,
			},
			legend: {
				layout: "horizontal",
				position: "top",
			},
			label: {
				type: "spider",
				labelHeight: 40,
				formatter: (data, mappingData) => {
					const group = new G.Group({});
					group?.addShape({
						type: "circle",
						attrs: {
							x: 0,
							y: 0,
							width: 40,
							height: 50,
							r: 5,
							fill: mappingData?.color,
						},
					});
					group?.addShape({
						type: "text",
						attrs: {
							x: 10,
							y: 8,
							text: `${data?.region}`,
							fill: mappingData?.color,
						},
					});
					group?.addShape({
						type: "text",
						attrs: {
							x: 0,
							y: 25,
							text: `${data?.count} [${(data?.percent * 100)?.toFixed(2)}%]`,
							fill: "rgba(0, 0, 0, 0.65)",
							fontWeight: 700,
						},
					});
					return group;
				},
			},
			interactions: [
				{
					type: "element-selected",
				},
				{
					type: "element-active",
				},
			],
		});
		useEffect(() => {
			if (TeamTitle && TeamTitle?.Region) {
				config.data = TeamTitle?.Region;
				setConfig(Object.assign({}, config));
			}
		}, [TeamTitle]);
		return <Pie {...config} />;
	};

	const columns = [
		{
			title: "Team",
			dataIndex: "esportTeamEn",
			key: "esportTeamEn",
			width: 200,
			sortOrder: sortState?.field == "esportTeamEn" && sortState?.order,
			sorter: (a, b) => a?.esportTeamEn?.localeCompare(b?.esportTeamEn),
			render: (text, record, index) => (
				<>
					<div className="Tabel_Company">
						<div
							className="Tabel_Company_Logo"
							style={{
								backgroundImage: `url(${
									record?.logo ||
									"data:image/png;base64,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"
								})`,
							}}
						></div>
						<div className="Tabel_Company_Title">
							<p>
								<span>{record?.esportTeamEn}</span>
							</p>
							<p>
								<span>{record?.esportTeamCn}</span>
							</p>
						</div>
					</div>
				</>
			),
		},
		{
			title: "Active Region",
			dataIndex: "region",
			key: "region",
			render: (text, record) => (
				<div>
					{record?.region?.length
						? record?.region?.map((vo, io) => <div key={io}>{vo}</div>)
						: "-"}
				</div>
			),

			sortOrder: sortState?.field == "region" && sortState?.order,
			sorter: (a, b) =>
				a?.region && b?.region && a?.region?.[0]?.localeCompare(b?.region?.[0]),
		},
		{
			title: "Games",
			dataIndex: "game",
			key: "game",
			width: 300,
			sortOrder: sortState?.field == "game" && sortState?.order,
			sorter: (a, b) => {
				a?.withGames?.[0]?.nameEn &&
					b?.withGames?.[0]?.nameEn &&
					a?.withGames?.[0]?.nameEn?.localeCompare(b?.withGames?.[0]?.nameEn);
			},
			render: (text, record, index) => (
				<>
					{text?.map((item, index) => {
						return (
							<div className="Tabel_Company" key={index}>
								<div className="Tabel_Company_Logo">
									<img src={item?.logo} />
								</div>
								<div className="Tabel_Company_Title">
									<p>
										<a href={`#/games/details/${item?.id}`} className="a_style">
											{item?.nameEn}
										</a>
									</p>
									<p>
										<a href={`#/games/details/${item?.id}`} className="a_style">
											{item?.nameCn}
										</a>
									</p>
								</div>
							</div>
						);
					})}
				</>
			),
		},
		{
			title: "Sponsors",
			dataIndex: "sponsor",
			key: "sponsor",
			render: (text, record, index) => (
				<>
					{record?.withSponsors?.map((item, index) => {
						return <p key={index}>{item?.name || ""}</p>;
					})}
				</>
			),
			sortOrder: sortState?.field == "sponsor" && sortState?.order,
			sorter: (a, b) => {
				a?.withSponsors?.[0]?.name &&
					b?.withSponsors?.[0]?.name &&
					a?.withSponsors?.[0]?.name?.localeCompare(b?.withSponsors?.[0]?.name);
			},
		},
		{
			title: "Website",
			dataIndex: "website",
			key: "website",
			render: (text, record, index) => (
				<>
					<div style={{ width: 700, wordBreak: "break-all" }}>
						{text || "-"}
					</div>
				</>
			),

			sortOrder: sortState?.field == "website" && sortState?.order,
			sorter: (a, b) => a?.website?.localeCompare(b?.website),
		},
	];
	useEffect(() => {
		if (state) {
			form.setFieldsValue({
				...state,
			});
			if (state.company) {
				form.setFieldsValue({
					company: state?.company,
				});
			}
		}
		effect(NTeam, EGet, { page: 1, perPage: 10, ...state });
		effect(NTeam, EGetOne, {});
		effect(NTeam, EGetType, {});
		effect(NGame, EGet, { page: 1, perPage: 10 });
		effect(NGame, EGetType, { page: 1, perPage: 10 });
		effect(NOrganizationMulti, EGetCompany, { page: 1, perPage: 10 });
		return () => {};
	}, []);

	const onSearchCompany = (value) => {
		effect(NOrganizationMulti, EGetCompany, {
			name: value,
			page: 1,
			perPage: 10,
		});
	};
	const onSearchGame = (value) => {
		effect(NGame, EGetType, { ...{ name: value }, page: 1, perPage: 10 });
	};
	const onSearchTeam = (value) => {
		effect(NTeam, EGetType, { ...{ team: value }, page: 1, perPage: 10 });
	};
	const onFinish = (values) => {
		setKeyword(values);
		effect(NTeam, EGet, {
			...values,
			page: 1,
			perPage: 10,
			field: sortState?.field,
			isDesc: sortState?.order && sortType[sortState?.order],
		});
	};

	const onReset = () => {
		setKeyword();
		form.resetFields();
		effect(NTeam, EGet, { page: 1, perPage: 10 });
	};

	return (
		<div>
			<Helmet>
				<script
					dangerouslySetInnerHTML={{
						__html: `
                            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                            })(window,document,'script','dataLayer','GTM-N9T2Q4PW');
                        `,
					}}
				/>
				{/* Google tag (gtag.js) */}
				<script
					async
					src="https://www.googletagmanager.com/gtag/js?id=G-6049TJDB50"
				></script>
				<script>
					{`
         				window.dataLayer = window.dataLayer || [];
        				function gtag(){dataLayer.push(arguments);}
          			gtag('js', new Date());
         				gtag('config', 'G-6049TJDB50');
        	`}
				</script>
			</Helmet>
			<div
				className="TeamsBox mt50"
				style={{ backgroundColor: "rgb(247, 249, 251)" }}
			>
				<Row gutter={24}>
					<Col span={8} style={{ paddingLeft: "50px" }}>
						<div className="Statistic_Box">
							<div className="Statistic_Card">
								<img src={Teams} />
								<div className="Statistic_Card_Sub">
									<div style={{ color: "#999999", fontSize: "22px" }}>
										Total Teams
									</div>
									<div style={{ fontSize: "30px", fontWeight: 600 }}>
										{TeamTitle?.total
											.toString()
											.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
									</div>
								</div>
							</div>

							<div className="Statistic_List">
								{TeamTitle?.Region?.map((item, index) => (
									<div key={index} className="Team_Area_List">
										<div>{item?.region}</div>
										<div>
											{item?.count
												?.toString()
												?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
										</div>
									</div>
								))}
							</div>
						</div>
					</Col>
					<Col span={14} style={{ paddingLeft: "100px" }}>
						<div className="CompanyChartBox">{CompanyCharts()}</div>
					</Col>
				</Row>
			</div>
			<Spin spinning={loading} size="large">
				<div
					className="BlogBox mt50"
					style={{ backgroundColor: "#F7F9FB", padding: "40px 40px 20px 0px" }}
				>
					<Form
						name="advanced_search"
						className="ant-advanced-search-form"
						labelCol={{ span: 8 }}
						form={form}
						onFinish={onFinish}
					>
						<Row>
							<Col span={8}>
								<Form.Item name="region" label="Region">
									<Select
										showArrow
										mode="multiple"
										getPopupContainer={(triggerNode) => triggerNode?.parentNode}
										placeholder="Select"
									>
										{E?.mainEnum?.map((vo, index) => (
											<Option key={index} value={vo?.text}>
												{vo?.text}
											</Option>
										))}
									</Select>
								</Form.Item>
							</Col>

							<Col span={8}>
								<Form.Item name="team" label="Team">
									<Select
										showArrow
										getPopupContainer={(triggerNode) => triggerNode?.parentNode}
										showSearch
										filterOption={false}
										placeholder="Select"
										onSearch={debounce((value) => {
											onSearchTeam(value);
										}, 300)}
									>
										{esportTeamSearch?.data?.map((item, index) => {
											return (
												<Option key={index} value={item?.esportTeamEn}>
													{item?.esportTeamEn}
												</Option>
											);
										})}
									</Select>
								</Form.Item>
							</Col>

							<Col span={8}>
								<Form.Item name="game" label="Games">
									<Select
										showArrow
										mode="multiple"
										getPopupContainer={(triggerNode) => triggerNode?.parentNode}
										showSearch
										filterOption={false}
										placeholder="Select"
										onSearch={debounce((value) => {
											onSearchGame(value);
										}, 100)}
									>
										{sortData(gameSearch?.data, "gameEn")?.map(
											(item, index) => {
												return (
													<Option key={index} value={item?.id}>
														{item?.gameEn}
													</Option>
												);
											}
										)}
									</Select>
								</Form.Item>
							</Col>
							<Col span={8}>
								<Form.Item name="sponsor" label="Sponsor(s)">
									<Select
										showArrow
										mode="multiple"
										getPopupContainer={(triggerNode) => triggerNode?.parentNode}
										showSearch
										filterOption={false}
										placeholder="Select"
										onSearch={debounce((value) => {
											onSearchCompany(value);
										}, 300)}
									>
										{sortData(OrganizationCompany?.data)?.map((item, index) => {
											return (
												<Option key={index} value={item?.id}>
													{item?.name}
												</Option>
											);
										})}
									</Select>
								</Form.Item>
							</Col>
							<Col span={16} style={{ textAlign: "right" }}>
								<Space>
									<Button
										type="primary"
										htmlType="submit"
										className="primarySearch"
									>
										Search
									</Button>
									<Button
										className="secReset"
										type="default"
										htmlType="button"
										onClick={() => {
											onReset();
											setSortState(null);
										}}
									>
										Reset
									</Button>
								</Space>
							</Col>
						</Row>
					</Form>
				</div>

				<div className="TeamsBox">
					<Row className="RowBox mt30">
						<Col span={24}>
							{TeamList?.error == 1009 ? (
								customizeRenderEmpty()
							) : (
								<Table
									locale={{ emptyText: CustomEmpty }}
									showSorterTooltip={false}
									scroll={{ x: "max-content" }}
									dataSource={TeamList?.data || []}
									columns={columns}
									className="CompanyTableBox"
									pagination={{
										current: parseInt(TeamList && TeamList?.page) || 1,
										total: (TeamList && TeamList?.total) || 0,
										defaultCurrent: 1,
										defaultPageSize:
											parseInt(TeamList && TeamList?.perPage) || 10,
										pageSize: TeamList && TeamList?.perPage,
										pageSizeOptions: ["10", "20", "30", "50", "100"],
										showQuickJumper: true,
										showSizeChanger: true,
										position: "bottom",
									}}
									onChange={(pagination, filters, sort) => {
										setSortState(sort);
										effect(NTeam, EGet, {
											...keyword,
											page: pagination?.current,
											perPage: pagination?.pageSize,
											field: sort?.column && sort?.field,
											isDesc:
												(sort?.column &&
													sort?.order &&
													sortType[sort?.order]) ||
												null,
										});
									}}
								/>
							)}
						</Col>
					</Row>
				</div>
			</Spin>
		</div>
	);
};
